// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"77932727","330":"dfc69187","620":"d48a8258","627":"547078b0","658":"dab4b1cc","681":"e456c2a5","787":"1226d2ac","886":"0d3595d8"}[chunkId] + ".chunk.js";
};